/**
 * @ngdoc service
 * @name common.service:ItxConfigurationSvc
 * @description
 * Configuration service wrapper wich gets properties from configuration JSON used in ITS.
 */
(function() {
    'use strict';

    angular
        .module('itxApp.common')
        .service('ItxConfigurationSvc', ItxConfigurationSvc);
        
    ItxConfigurationSvc.$inject = [
        'CommonServices',
        'preCommonCmsConfigSvc'
    ];

    function ItxConfigurationSvc(
        CommonServices,
        preCommonCmsConfigSvc
    ) {

        var service = {
            // ITS CONFIG DEPRECATED
            get: _get,
            getChatConfiguration: _getChatConfiguration,
            hasCrespon: _hasCrespon,
            showInMiles: _showInMiles,
            isSeoUrlsEnabled: _isSeoUrlsEnabled,
            isBgEnable: isBgEnable,
            
            getEnvironment: _getEnvironment,
            setDebugOptions: setDebugOptions,
            getDebugOptions: getDebugOptions,

            // functions Deprecated. Se debe utilizar el servicio CommonServices
            isDebugActive: CommonServices.isDebugActive,
            getCmsStaticPath: preCommonCmsConfigSvc.getCmsStaticPath,
            getCmsApiPath: preCommonCmsConfigSvc.getCmsApiPath,
            getApiPath: CommonServices.getApiPath,
            useCmsApi: preCommonCmsConfigSvc.useCmsApi
        };

        return service;

        function _isDebugActive() {
            var debugActive = (inditex.getSessionStorage('DebugActive')  ? true : false);
            return debugActive;
        }
        
        function getDebugOptions() {
            var options = inditex.getSessionStorage('DebugOptions');
            if(options){
                return JSON.parse(options);
            } else {
                return {
                    properties: false,
                    timeTraveler: false,
                    productInfo: false,
                    showCategoryIds: false
                };
            }
        }

        function setDebugOptions(obj) {
            inditex.setSessionStorage('DebugOptions', obj);
        }

        /**
         * Obtención de configuraciones
         */
        function _get(propertyName) {

            var res = false;

            if (_.has(window.configurationContent, 'properties')) {

                if (_.has(window.configurationContent.properties, propertyName)) {
                    
                    res = window.configurationContent['properties'][propertyName];
                }
            }

            return res;
        }

        function _getChatConfiguration() {
            return _get('chat');
        }

        function _hasCrespon() {
            return _get('cresponEnabled');
        }

        function _showInMiles() {
            return _get('showInMiles');
        }

        function _isSeoUrlsEnabled() {
            return _get('seoUrlsEnabled');
        }

        function isBgEnable() {
            return false;
        }

        function _getEnvironment() {
            var environment;
            switch(window.location.hostname){
                case 'localhost':
                    environment = 'DEVELOPMENT';
                    break;
                case 'int-massimoduttiphr.inditex.com':
                    environment = 'DEVELOPMENT';
                    break;
                case 'axpreprueccwpslb1-massimodutti.central.inditex.grp':
                    environment = 'PREPRU';
                    break;
                case 'dyn-massimoduttiphr.inditex.com':
                    environment = 'PRUSTG';
                    break;
                case 'axpreprustgeccwpslb1-massimodutti.central.inditex.grp':
                    environment = 'PRUSTG';
                    break;
                case 'axinstgeccwps1-massimodutti.central.inditex.grp':
                    environment = 'STAGE';
                    break;
                default:
                    environment = 'PRO';
                    break;
            }
            return environment;
        }

    }

})();
